import AdvantageSection from '@/v2/components/sections/home/advantage-section'
import EvenOddSection from '@/v2/components/sections/home/even-odd-section'
import Features from '@/v2/components/sections/home/features-section'
import PressAndReleaseSection from '@/v2/components/sections/home/press-and-release-section'
import ReviewsSection from '@/v2/components/sections/home/reviews-section'
import StorageFeaturesSection from '@/v2/components/sections/home/storage-features-section'
import WhyDifferentSection from '@/v2/components/sections/home/why-different-section'
import {
  advantageSectionContent,
  evenOddSectionContent,
  featuresSectionContent,
  reviewsContent,
  storageFeaturesSectionContent,
  WhyDifferentSectionContent
} from '@/v2/constants/pages/public-pages/home-page'
import { pressNews } from '@/v2/constants/pages/public-pages/press-news'

interface HomePageProps {}

const HomePage: React.FC<HomePageProps> = () => {
  return (
    <>
      <Features
        title={
          <h2>
            How <span>Smart Storage</span> Works
          </h2>
        }
        description={featuresSectionContent.description}
        cards={featuresSectionContent.cards}
      />

      <WhyDifferentSection
        title={
          <h2>
            We Brought <span>Customized</span> Solution
          </h2>
        }
        cards={WhyDifferentSectionContent.cards}
        ctaButton={WhyDifferentSectionContent.ctaButton}
      />

      <EvenOddSection
        title={
          <h2>
            Your One Stop Place <span>For Storage and Shipping</span> Services
          </h2>
        }
        articles={evenOddSectionContent.articles}
      />

      <AdvantageSection
        title={
          <h2>
            Ship and Storage <span>Advantage</span>
          </h2>
        }
        cards={advantageSectionContent.cards}
        ctaButton={advantageSectionContent.ctaButton}
      />

      <StorageFeaturesSection
        title={
          <h2>
            What We <span>Store</span>
          </h2>
        }
        cards={storageFeaturesSectionContent.cards}
      />

      {pressNews.length > 0 && (
        <PressAndReleaseSection
          title={
            <h2>
              News <span>& Press</span>
            </h2>
          }
          articles={pressNews}
        />
      )}

      <ReviewsSection
        title={
          <h2>
            What People Say <span>About Our Services</span>
          </h2>
        }
        reviews={reviewsContent}
      />
    </>
  )
}

export default HomePage
